import { getValue } from './helpers.js'
import View from './view.js'

export default function Logic(props) {
  return <View {...props} text={getValue(props.value)} />
}
